var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNonProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_567_32046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 22.4583C29.0105 22.4583 32.6668 18.802 32.6668 14.2917C32.6668 9.78134 29.0105 6.125 24.5002 6.125C19.9898 6.125 16.3335 9.78134 16.3335 14.2917C16.3335 18.802 19.9898 22.4583 24.5002 22.4583Z",
    stroke: "#C3C3C3",
    strokeWidth: 3.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 42.875V38.7917C12.25 36.6257 13.1104 34.5485 14.642 33.017C16.1735 31.4854 18.2507 30.625 20.4167 30.625H28.5833C30.7493 30.625 32.8265 31.4854 34.358 33.017C35.8896 34.5485 36.75 36.6257 36.75 38.7917V42.875",
    stroke: "#C3C3C3",
    strokeWidth: 3.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_567_32046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonProfile);
export default __webpack_public_path__ + "static/media/non-profile.348fc15b9a354324c3acc959739dbb37.svg";
export { ForwardRef as ReactComponent };